import countries from "../data/country-by-abbreviation";

export const getCountryOptions = [
  ...countries.map((country, index) => ({
    label: `${country.country} (${country.abbreviation})`,
    value: country.country,
  })),
];
